import { randomInt } from '../../lib/random';

/**
 * La bulle de notification — le gag le plus reconnaissable de XP.
 *
 * Tout ce qui se décide ici est pur : quel message sort, et dans combien de
 * temps sort le suivant. Le composant ne fait que poser des `setTimeout` sur ces
 * réponses, ce qui permet de tester la règle « jamais deux fois le même message
 * de suite » sans attendre soixante secondes.
 */

/** Délai avant la toute première bulle, en millisecondes. */
export const FIRST_DELAY_MS = 6_000;

/** Fourchette entre deux bulles (cf. handoff : 45 à 70 s). */
export const MIN_GAP_MS = 45_000;
export const MAX_GAP_MS = 70_000;

/** Durée d'affichage avant fermeture automatique. */
export const VISIBLE_MS = 9_000;

/** Tirage d'un entier dans [0, max[ — injectable pour les tests. */
export type PickIndex = (max: number) => number;

/**
 * Tire l'index du prochain message, **jamais celui qui vient d'être montré**.
 *
 * `previous` vaut -1 pour la première bulle. Avec un seul message en réserve, on
 * le remontre : mieux vaut se répéter que de ne plus rien dire.
 */
export function nextTip(count: number, previous: number, pick: PickIndex = randomInt): number {
  if (count <= 0) return -1;
  if (previous < 0 || previous >= count) return pick(count);
  if (count === 1) return 0;

  // On tire parmi les `count - 1` autres, puis on saute par-dessus le précédent :
  // chaque message restant garde exactement la même chance de sortir.
  const drawn = pick(count - 1);
  return drawn < previous ? drawn : drawn + 1;
}

/** Attente avant la bulle suivante, dans la fourchette du handoff. */
export function nextDelay(pick: PickIndex = randomInt): number {
  return MIN_GAP_MS + pick(MAX_GAP_MS - MIN_GAP_MS + 1);
}
